/**
 * constante para simular importacion de @siigo/aivo
 */
export const AIVO = "Aivo";
